module.exports = __webpack_public_path__ + "static/UtilitiumIcon-0d32a147893caf651973aa9e77f9219e.png";